var CommSummaryCommunities = React.createClass({
  propTypes: {
    communities: React.PropTypes.arrayOf(React.PropTypes.object),
    onCommunityClicked: React.PropTypes.func,
  },
  getDefaultProps() {
    return {
      communities: []
    }
  },
  communityClicked(id) {
    if (this.props.onCommunityClicked) {
      this.props.onCommunityClicked(id);
    }
  },
  renderItem(community) {
    return (
        <li className="" key={community.id}>
          <a href="#" onClick={this.communityClicked.bind(this, community.id)}>{community.name}</a> <span className="text-muted">({community.hits})</span>
        </li>
      )
  },

  render() {
    if (this.props.communities.length == 0) {
      return <div></div>;
    }

    let items = this.props.communities.map(this.renderItem);

    return (
      <div className="cat-matches">
        <h3 className="cat-matches__title">{Labels.getLabel("Show results in these communities")}:</h3>
        <ul className="cat-matches__list bullet-list">
          {items}
        </ul>
      </div>
    )
  }
});